export default __webpack_public_path__ + "static/media/Preview4.c7de14c8.jpg";